<template>
  <div class="modal-drag-custom-drag limit-height-size" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			:resizable="false"
			height="auto"
			width="90%"
			:maxWidth="900"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" small class="info-icon mr-2">mdi-account</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Detalle Cliente</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-4">
					<div fluid class="crm-conversation">
						<v-row class="mb-4" v-if="$store.state.users.loadingClient">
							<v-col cols="12">
								<div class="d-flex flex-column justify-center align-center">
									<v-progress-circular
										:size="50"
										:width="5"
										color="rgba(0,0,0,0.2)"
										class="mb-3"
										indeterminate
									></v-progress-circular>
									Cargando Información
								</div>
							</v-col>
						</v-row>
						<div v-else-if="client">
							<v-row>
								<v-col cols="12" v-show="!hideFirstCol" style="overflow-y:scroll;" :style="'height:'+$store.getters['general/availableHeight']+'px'">
									<v-card class="mb-4">
										<v-card-text class="py-2">
											<div class="d-flex align-center justify-space-between">
												<div class="d-flex align-center">
													<p class="font-weight-bold body-2 mb-0 mr-2">Datos Cliente</p>
													<!-- <v-btn
														icon
														color="#524D4D"
														@click="editUser = !editUser"
														:disabled="!editPermission"
													>
														<v-icon>{{editUser ? 'mdi-close':'mdi-account-box-edit-outline'}}</v-icon>
													</v-btn> -->
												</div>
											</div>
											<v-divider class="my-1"></v-divider>
											<div class="pa-2" v-if="client">
												<div v-if="editUser">
													<div class="d-flex justify-space-between align-center mb-1">
														<span class="mr-5">Nombre: </span>
														<v-text-field
															v-model="userData.name"
															outlined
															required
															dense
															hide-details
															style="max-width: 75%"
														></v-text-field>
													</div>
													<div class="d-flex justify-space-between align-center mb-1">
														<span class="mr-5">Email: </span>
														<v-text-field
															v-model="userData.email"
															outlined
															required
															dense
															hide-details
															style="max-width: 75%"
														></v-text-field>
													</div>
													<div class="d-flex justify-space-between align-center mb-1">
														<span class="mr-5">Teléfono: </span>
														<v-text-field
															v-model="userData.phone"
															outlined
															required
															dense
															style="max-width: 75%"
															:rules="phoneRule"
															maxlength="11"
															@keypress="isNumberKey"
														></v-text-field>
													</div>
													<v-btn
														depressed
														color="#524D4D"
														dark
														block
														small
														class="mt-3"
														:loading="loadingEditUser"
														@click="editUserData()"
													>
														<v-icon small>mdi-account-edit</v-icon>
														<p class="mb-0 ml-2 caption">Confirmar Cambios</p>
													</v-btn>
												</div>
												<div v-else>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.profile.name}} {{client.profile.lastname}} {{client.profile.second_lastname}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.email}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.profile.phone}}</b></div>
												</div>
												<v-divider class="my-2"></v-divider>
												<div v-if="client.company_profile">
													<div class="mb-3 d-flex align-center justify-space-between">
														<p class="mb-0 caption font-weight-bold">Datos empresa</p>
														<v-btn
															color="#524D4D"
															dark
															outlined
															x-small
															@click="showCompanyProfile = !showCompanyProfile"
														>
															<p class="mb-0 mr-2 caption">{{ showCompanyProfile ? 'Ocultar Datos Empresa':'Mostrar Datos Empresa' }}</p>
															<v-icon small>{{ showCompanyProfile ? 'mdi-chevron-up':'mdi-chevron-down' }}</v-icon>
														</v-btn>
													</div>
													<v-row v-show="showCompanyProfile">
														<v-col cols="12">
															<div class="mb-3 d-flex align-center justify-space-between">
																<p class="mb-0 caption font-weight-bold mr-5" v-if="client.accreditation && client.accreditation.status">Los contratos que hagas con este cliente usarán los datos empresa</p>
																<p class="mb-0 caption font-weight-bold mr-5" v-else>Acepta si quieres permitir al cliente usar sus datos empresa</p>
																<v-btn
																	:color="client.accreditation && client.accreditation.status ? '#FF120B':'#524D4D'"
																	dark
																	outlined
																	small
																	v-if="showCompanyProfile"
																	@click="changeAccreditationStatus"
																>
																	<v-icon small>mdi-account-details-outline</v-icon>
																	<p class="mb-0 ml-2 caption" v-if="client.accreditation && client.accreditation.status">Revocar Usuario Empresa</p>
																	<p class="mb-0 ml-2 caption" v-else>Aceptar Usuario Empresa</p>
																</v-btn>
															</div>
														</v-col>
														<v-col cols="12">
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre Empresa</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.name}}</b></div>
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rut | formatRut}}</b></div>
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.email}}</b></div>
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.phone}}</b></div>
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.address}}</b></div>
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rep_name}} {{client.company_profile.rep_first_lname}} {{client.company_profile.rep_second_lastname}}</b></div>
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.email}}</b></div>
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rep_rut | formatRut}}</b></div>
															<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rep_address}}</b></div>
															<v-divider class="my-2"></v-divider>
															<v-row>
																<v-col cols="12">
																	<p class="mb-0 caption font-weight-bold">Documentos para Acreditación de la Información</p>
																</v-col>
																<v-col
																	cols="12"
																	sm="6"
																	v-for="(file) in client.accreditation_documents"
																	:key="file.id"
																>
																	<v-btn
																		color="#524D4D"
																		dark
																		outlined
																		block
																		@click="toDocumentUrl(file)"
																	>
																		<v-icon small>mdi-download</v-icon>
																		<p class="mb-0 ml-2 caption">
																			{{ getFileAccreditationName(file) }}
																		</p>
																	</v-btn>
																</v-col>
															</v-row>
														</v-col>
													</v-row>
												</div>
											</div>
											<div class="pa-2" v-else>
												No se logró obtener datos de usuario
											</div>
										</v-card-text>
									</v-card>
									<v-tabs v-model="tab" class="custom-color-tabs" show-arrows grow @change="onChangeTabFromClick">
										<v-tab>CRM / Solicitudes</v-tab>
										<v-tab>Antecedentes</v-tab>
										<v-tab>Informes</v-tab>
										<v-tab>Presupuestos</v-tab>
										<v-tab>Contratos Y Costos</v-tab>
										<v-tab>Proyectos</v-tab>
										<v-tab>Supervisión de Obra /<br/> Construcción</v-tab>
									</v-tabs>
									<v-tabs-items v-model="tab" class="tab-item-custom" style="width: 100%; flex-grow: 1;">
										<v-tab-item>
											<div>
												<CrmList :clientId="clientId" :openCrmDetail="handleOpenCrmDetail" />
											</div>
										</v-tab-item>
										<v-tab-item>
											<div>
												<PreProjectList :clientId="clientId" :openPreProjectDetail="handleOpenPreProjectDetail" />
											</div>
										</v-tab-item>
										<v-tab-item>
											<div class="pa-4">
												<ReportList :clientId="clientId" :openReportDetail="handleOpenReportDetail"/>
											</div>
										</v-tab-item>
										<v-tab-item>
											<div class="pa-4">
												<BudgetList :clientId="clientId" :openBudgetDetail="handleOpenBudgetDetail" />
											</div>
										</v-tab-item>
										<v-tab-item>
											<div class="pa-4">
												<ContractList :clientId="clientId" :openContractDetail="handleOpenContractDetail" />
											</div>
										</v-tab-item>
									</v-tabs-items>
								</v-col>
							</v-row>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</modal>
	</div>
</template>

<script>
import { setCompanyAccreditationUserStatus } from '@/helpers/api/user/index.js'
import {getReportById} from '@/helpers/api/reports'

import CrmList from '@/components/Views/Clients/Parts/CRM'
import PreProjectList from '@/components/Views/Clients/Parts/PreProjects'
import ContractList from '@/components/Views/Clients/Parts/Contracts/index'
import BudgetList from '@/components/Views/Clients/Parts/Budgets/index'
import ReportList from '@/components/Views/Clients/Parts/Reports/index'

export default {
	name: 'ClientDetail',
  components: { CrmList, PreProjectList, ContractList, BudgetList, ReportList },
  data() {
    return {
			indexModal: + new Date(),
			hideFirstCol: false,
			clientId: null,
			selectedCrmId: null,
			selectedPreProjectId: null,
			selectedContractId: null,
			selectedBudgetId: null,
			selectedReportId: null,
			mapZoom: 7,
      zoomInterval: null,
      isZooming: false,
			itemsAddress: [],
			loadingAddress: false,
			search: '',
			autocompleteService: null,
			tab: null,
			items: ['Información', 'Conversación', 'Correos Enviados', 'Informes'],
			reportTemplate: null,
			loading: false,
			editValue: false,
			editProjectDetail: false,
			editScheduleTitle: false,
			editUser: false,
			editAddress: false,
			newValueCrm: null,
			newScheduleTitle: null,
			newProjectDetail: null,
			loadingEditUser: false,
			reportEditor: '',
			menuTemplates: false,
			cc_report: null,
			scheduledUserId: null,
			changingScheduleUser: false,
			subject: 'Informe Visita Técnica',
			report_title: 'Informe Visita Técnica Revisión Normativa',
			activePanel: null,
			activePanelB: null,
			templateName: null,
			userData: {
				name: null,
				email: null,
				phone: null
			},
			cachingItems: false,
			newAddress: {address: null, coordinates: null},
			showCompanyProfile: false,
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			phoneRule: [
				v => !!v || 'Campo requerido',
				v => /^569\d{8}$/.test(v) || 'Debe tener 11 dígitos y empezar con 569',
			],
    };
  },
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		editPermission(){
			return true
		},
		client(){
			return this.$store.state.users.client
		},
		queryRoute(){
			return this.$route.query
		}
  },
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.clientId = parseInt(this.$store.state.users.clientModalInfo.id)
				try {
					this.$store.dispatch('users/getCompanyClient', this.clientId)
				} catch (error) {
					console.log('Error: ', error)
				}
			}
		}
	},
	mounted(){
		if(this.$store.state.users.clientModalInfo){
			this.clientId = parseInt(this.$store.state.users.clientModalInfo.id)
			this.$store.dispatch('users/getCompanyClient', this.clientId)
		}
		this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
	},
	beforeDestroy(){
		this.$store.commit('users/setClient', null)
	},
  methods: {
    closeModal(){
			this.$store.commit('users/setClientModal', false)
			this.$store.commit('users/setClientModalInfo', null)
      this.clientId = null
    },
		onChangeTabFromClick(){
			this.setAllSelectedToValue()
		},
		changeColSize(){
			this.hideFirstCol = !this.hideFirstCol
		},
		handleOpenCrmDetail(crm_id){
			this.setAllSelectedToValue()
			this.selectedCrmId = crm_id
			this.$store.commit('crm/setCrmModalId', crm_id)
			// this.$router.replace({  query: {crm: crm_id} }).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
		},
		handleOpenPreProjectDetail(preproject_id){
			this.setAllSelectedToValue()
			this.selectedPreProjectId = preproject_id
			this.$store.commit('preprojects/setPreProjectModalId', preproject_id)
			// this.$router.replace({  query: {p: preproject_id} }).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
		},
		handleOpenContractDetail(contract_id){
			this.setAllSelectedToValue()
			this.selectedContractId = contract_id
			this.$store.commit('contracts/setContractModalId', contract_id)
		},
		handleOpenBudgetDetail(budget_id){
			this.setAllSelectedToValue()
			this.selectedBudgetId = budget_id
			this.$store.commit('budget/setBudgetModalId', budget_id)
			// this.$router.replace({  query: {b: budget_id} }).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
		},
		handleOpenReportDetail(report_id){
			this.setAllSelectedToValue()
			this.selectedReportId = report_id
			this.getReport()
			// this.$router.replace({  query: {r: report_id} }).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
		},
		async getReport(){
			const report = await getReportById({report_id: this.selectedReportId})
			if(report.code == 200){
				this.$store.commit('reports/setReportPdfModal', {...report.report, ...{viewer_only: true, is_client: true}})
			}
		},
		setAllSelectedToValue(value = null){
			this.selectedCrmId = value
			this.selectedPreProjectId = value
			this.selectedContractId = value
			this.selectedBudgetId = value
			this.selectedReportId = value
		},
		toConversationDetail(crm) {
			// this.$router.push({ name: 'Conversation', params: { id: crm.id } })
			this.$store.commit('crm/setCrmModalId', crm.id)
		},
		toPreProjectDetail(preproject) {
			// this.$router.push({ name: 'PreProject', params: { id: preproject.id } })
			this.$store.commit('preprojects/setPreProjectModalId', preproject.id)
		},
		toDocumentUrl(file){
			window.open(file.file?.file_link, '_blank')
		},
		getFileAccreditationName(file){
			switch (file.type) {
				case 1:
					return 'Comprobante Dirección Usuario'
				case 2:
					return 'Certificado de Vigencia'
				case 3:
					return 'Estatuto Actualizado'
				case 4:
					return 'Escritura Constitución de Sociedad'
				case 5:
					return 'Comprobante Dirección RL'
			
				default:
					break;
			}
		},
		async changeAccreditationStatus(){
			const currentStatus = this.client.accreditation && this.client.accreditation.status
			const newStatus = !currentStatus
			await setCompanyAccreditationUserStatus({
				user_id: this.client.id,
				status: newStatus
			})
			this.$store.dispatch('users/getCompanyClient', this.client.id)
		}
  },
};
</script>

<style scoped>
	.client-items-container{
		border: 1px solid rgb(213, 211, 211);
	}
	.single-message{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		margin-bottom: 8px;
		text-transform: none;
	}
	.single-message.assistant{
		background-color: rgb(213, 211, 211);
		border: 1px solid rgb(193, 191, 191);
		align-self: flex-end;
	}
	.template-list-item:hover{
		background-color: rgba(0,0,0,0.2);
	}
	.menu-bg-white{background: white;}
	.vertical-tabs .rotated-tab {
		writing-mode: vertical-lr;
		transform: rotate(180deg);
		text-align: center;
		height: 150px;
		line-height: 1;
	}

	.vertical-tabs .v-tab {
		justify-content: center;
		align-items: center;
		min-height: 100px;
		padding: 0px;
		min-width: 40px;
		width: 40px;
		font-size: 12px;
	}
	.vertical-tabs {
		align-items: flex-start;
		height: 100%;
	}
	.custom-color-tabs .v-tab{
		font-size: 12px;
	}
	.custom-color-tabs .v-tab.v-tab--active {
		background-color: #FF120B;
		color: #FFFFFF;
	}
	.custom-color-tabs .v-tab:not(.v-tab--active) {
		background-color: white;
		color: #000000!important;
	}
	.change-col-size{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
</style>
<style>
	.crm-conversation .single-message p{
		margin-bottom: 0;
	}
	.tab-item-custom .v-window__container{height: auto;}
</style>